// Per-step time estimate. Guidance only, never enforced.
export const StepEstimate = ({ minutes }) => (
  <span data-testid="step-estimate" className="mono-label text-ink/50">
    about {minutes} minutes
  </span>
);
